import axios from 'axios';
import {systemVariables} from "@/config";

class AxiosService {
    constructor() {
        this.instance = axios.create({
            baseURL: systemVariables.apiUrl,
            params: {},
            headers: {
              'Accept': 'application/json',
          },
        });

        // Aggiorna il token all'inizio
        this.updateToken();

        // Interceptor per la gestione degli errori
        this.instance.interceptors.response.use(
            response => {
                const data = response.data.data;
                // Check if the response contains errors despite the 200 status code
                if (data && data.errors && typeof data.errors === 'object') {
                    // Retrieve the first error message from the nested object
                    const firstErrorMessage = this.extractFirstError(data.errors);
                    if (firstErrorMessage) {
                      throw new Error(firstErrorMessage);
                    }
                  }
                return response; // Return the response if no errors found
            },
            (error) => {
                // if (error.response && error.response.status === 401) {
                //   return Promise.reject();
                //     //localStorage.clear();
                //     //window.location.href = "/";
                // }
                return Promise.reject(error);
            }
        );
    }

    extractFirstError(errors, parentKey = '') {
        for (const key in errors) {
          const fullKey = parentKey ? `${parentKey}.${key}` : key;
          if (errors[key] && typeof errors[key] === 'object') {
            return this.extractFirstError(errors[key], fullKey); // Recursively find the first message
          } else if (errors[key]) {
            return fullKey + ': ' + errors[key]; // Return the first key and message
          }
        }
        return '';
      }

    // Metodo per aggiornare il token
    updateToken() {
        const token = localStorage.getItem('authToken') || '';
        this.instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    // Ritorna l'istanza Axios
    getInstance() {
        return this.instance;
    }
}

export const axiosService = new AxiosService();
